// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__VDwgK","tagButton":"styles_tagButton__s13pk","icon":"styles_icon__Kh4yE","label":"styles_label___WmBj"};